export const rbdMockDate = '20.04.2023 12:13:25';
